import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import apiClient from "../services/apiClient";
import TelegramConnectDialog from "./TelegramConnectDialog";
import "./TelegramConnectDialog.css";

/**
 * 첫 화면 텔레그램 연결 팝업(2026-09-30). 아직 텔레그램을 잇지 않은 계정에만 띄운다.
 * 이것이 뜬 날에는 안내 팝업(ExperiencePromoModal)을 띄우지 않는다. 두 개가 겹치지 않게
 * onResolved(띄웠는지) 로 HomePage 에 알린다. 운영진 보기 중에는 띄우지 않는다.
 */
const HIDDEN_UNTIL_KEY = "telegram_prompt_hidden_until";
const todayString = () => new Date().toISOString().slice(0, 10);

const TelegramPromptModal = ({ onResolved }) => {
  const { user } = useSelector((state) => state.auth);
  const [isOpen, setIsOpen] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);

  useEffect(() => {
    let hidden = false;
    try {
      const hiddenUntil = localStorage.getItem(HIDDEN_UNTIL_KEY);
      hidden = Boolean(hiddenUntil && hiddenUntil >= todayString());
    } catch (error) {
      hidden = false;
    }
    if (hidden || user.admin_viewer_name) {
      onResolved(false);
      return;
    }
    apiClient
      .get("/api/v1/echo/teacher/telegram", { withAuth: true })
      .then((response) => {
        // 학원 계정에 누가 이었든, 지금 들어온 선생님 본인이 안 이었으면 띄운다(my_connected)
        const shouldOpen = response.data.enabled && !response.data.my_connected;
        setIsOpen(shouldOpen);
        onResolved(shouldOpen);
      })
      .catch(() => onResolved(false));
  }, [onResolved, user.admin_viewer_name]);

  if (!isOpen) return null;

  const close = () => setIsOpen(false);
  const hideToday = () => {
    try {
      localStorage.setItem(HIDDEN_UNTIL_KEY, todayString());
    } catch (error) {
      /* 저장 실패는 무시한다 */
    }
    setIsOpen(false);
  };
  const connect = () => setDialogOpen(true);

  if (dialogOpen) {
    return <TelegramConnectDialog onClose={hideToday} />;
  }

  return (
    <div onClick={close} style={{ position: "fixed", inset: 0, background: "rgba(14, 20, 27, 0.45)", zIndex: 2000,
      display: "flex", alignItems: "center", justifyContent: "center", padding: "20px" }}>
      <div onClick={(event) => event.stopPropagation()} style={{ width: "100%", maxWidth: "460px", background: "#fff",
        borderRadius: "20px", overflow: "hidden", boxShadow: "0 24px 64px rgba(14, 20, 27, 0.3)" }}>
        <div style={{ padding: "30px 28px 24px", background: "#0E141B" }}>
          <p style={{ fontSize: "0.76rem", fontWeight: 700, letterSpacing: "0.22em", color: "#00D9C0", margin: 0 }}>
            PUSH ALARM
          </p>
          <h2 style={{ fontSize: "1.35rem", fontWeight: 900, lineHeight: 1.4, margin: "10px 0 0", color: "#fff", letterSpacing: "-0.02em" }}>
            앞으로 푸시 알림으로
            <br />
            <span style={{ color: "#00D9C0" }}>레벨테스트 · 학습 내역</span>을 다 받아 보세요!
          </h2>
          <p style={{ fontSize: "0.86rem", color: "#c9d3d8", lineHeight: 1.7, margin: "10px 0 0" }}>
            텔레그램을 한 번만 연결해 두면 출제 · 학습 완료 ·
            <br />
            레벨테스트 응시와 리포트까지 바로 알려 드려요 📲
          </p>
        </div>
        <div style={{ padding: "20px 28px 16px" }}>
          <ol style={{ margin: "0 0 14px", paddingLeft: "18px", fontSize: "0.86rem", color: "#3A434E", lineHeight: 1.8 }}>
            <li>아래 버튼을 누르면 QR 이 떠요. 휴대폰 카메라로 찍어요</li>
            <li>텔레그램 ginecho_bot 대화방에서 <b>시작</b>을 누르면 끝!</li>
          </ol>
          <button type="button" onClick={connect} style={{ width: "100%", border: "none", borderRadius: "13px", padding: "15px",
            background: "#229ED9", color: "#fff", fontWeight: 800, fontSize: "1rem", cursor: "pointer", fontFamily: "inherit" }}>
            텔레그램 연결하기
          </button>
          <div style={{ display: "flex", justifyContent: "space-between", marginTop: "14px", padding: "0 2px" }}>
            <button type="button" onClick={hideToday} style={{ border: "none", background: "none", color: "#8a949c",
              fontSize: "0.82rem", fontWeight: 600, cursor: "pointer", fontFamily: "inherit", padding: 0 }}>
              오늘 하루 보지 않기
            </button>
            <button type="button" onClick={close} style={{ border: "none", background: "none", color: "#3A434E",
              fontSize: "0.82rem", fontWeight: 700, cursor: "pointer", fontFamily: "inherit", padding: 0 }}>
              닫기 ✕
            </button>
          </div>
          <p style={{ margin: "10px 0 0", fontSize: "0.74rem", color: "#8a949c", textAlign: "center" }}>
            나중에는 오른쪽 위 계정 메뉴의 '텔레그램 알림' 에서 연결할 수 있어요
          </p>
        </div>
      </div>
    </div>
  );
};

export default TelegramPromptModal;
